import { useAuth } from "@/context/AuthContext";
import { SettingsProvider } from "@/context/SettingsContext";
import MemberDashboard from "@/components/member/MemberDashboard";
import StaffDashboard from "@/components/staff/StaffDashboard";
import AdminDashboard from "@/components/admin/AdminDashboard";

export default function Portal() {
  const { user } = useAuth();
  if (!user) return null;
  return (
    <SettingsProvider>
      {user.role === "admin" ? <AdminDashboard />
        : user.role === "staff" ? <StaffDashboard />
        : <MemberDashboard />}
    </SettingsProvider>
  );
}
